<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page="selected_page" :user_status='user_status'></rosidebar>
				<el-dialog :title="notify_title" :visible.sync="notifyDialogVisible" width="60%" top='15%'>
					<div v-html="notify_message"/>
					 <span slot="footer" class="dialog-footer">
					    <el-button type="primary" @click="notifyDialogVisible = false">确 定</el-button>
					  </span>
					  
					</el-dialog>
					
				<div
					style="float: right;width:calc(100% - 269px);overflow: hidden;height:1090px;background: white;border-radius: 5px;">
					<h6 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						<!-- 您的位置： -->
						<!-- <span style="color:gray;">首页</span> > <span style="color:gray;">个人中心</span> > -->
						<span style="color:#07ccec;">消息通知</span>
					</h6>
					<!-- <div style="width: 95%;height:60px;margin:20px auto;border: 2px dotted #F0F0F0;padding:0 10px;">
						<span style="float: left;line-height: 60px;">读取状态：</span>
						<el-row style="float: left;margin-top: 13px;">
							<el-button plain size="small">全部</el-button>
							<el-button plain size="small">已读</el-button>
							<el-button plain size="small">未读</el-button>
						</el-row>
					</div> -->
					<!-- <div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">
					
					<el-row style="float: left;margin-top: 6px;"><el-button plain size="small">全部</el-button>
					<el-button plain size="small">已读</el-button>
					<el-button plain size="small">未读</el-button>
					</el-row>
						<el-pagination style="float: right;margin-top: 8px;" :page-sizes="[5, 10]" :page-size="5"
							layout="sizes, prev, pager, next" :total="user_notice_total.length" >
						</el-pagination>
					</div> -->
					<div style="width: 95%;height:40px;margin:20px auto;padding:0 10px;background-color: #e7f5fc;">
						<el-row style="float: left;margin-top: 4px;">
							<el-button size="small" @click="delete_message()">删除</el-button>
							<el-button size="small" @click="set_message_as_read()">标记为已读</el-button>
						</el-row>
						<el-pagination style=";margin-top: 8px;float: right;"  @current-change="handleCurrentChange"
							:current-page="currentPage"  :page-size="PageSize" background
							layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<el-table ref="multipleTable" :data="user_notice_datas" tooltip-effect="dark"
						style="width: 95%;margin:auto;" @selection-change="handleSelectionChange"
						@cell-click="handleCellClick" :row-class-name="tableRowClassName">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column label="日期" width="220">
							<template slot-scope="scope">{{ scope.row.date }}</template>
						</el-table-column>
						<!-- 				<el-table-column prop="message_type" label="消息类型" width="220">
						</el-table-column> -->
						<el-table-column prop="content" label="消息摘要" show-overflow-tooltip>
						</el-table-column>
						<!-- <el-table-column prop="has_read" label="已读">
							<template slot-scope="scope">
								<i class="el-icon-check" style="margin-right:5px;color:green;"></i>
								<i class="el-icon-close" style="margin-right:5px;color:red;"></i>
							</template>
						</el-table-column> -->
					</el-table>

				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'user_notice',
		data() {
			return {
				notify_title:'',
				notify_message:'',
				dialogVisible:false,
				notifyDialogVisible:false,
				user_status: '已登录',
				selected_page: '1-1',
				user_notice_datas: [],
				currentPage: 1,
				// 总条数，根据接口获取数据长度(注意：这里不能为空)
				totalCount: 0,
				// 个数选择器（可修改）
				// 默认每页显示的条数（可修改）
				PageSize: 12,
			}
		},
		mounted() {
			var self = this
			this.get_message_data()
			// fetchGet('/ro/report_data_center/fcst/datas/sale').then(function(data) {
			// 	// debugger;
			// 	self.customer_options = data.data['partner_data']
			// 	self.product_options = data.data['product_data']
			// 	// self.tableData = data.data['partner_data']
			// 	console.log(self.tableData)

			// })

			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,

		},
		methods: {
			handleClose() {
				this.dialogVisible = false
				// this.turn_to_order_info()
			},
			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_message_data()
			},
			
			delete_message() {
				var ids = this.multipleSelection.map(item => item.id)
				var data = {
					'ids': JSON.stringify(ids)
				}
				var self = this
				fetchPost('/ro/tec_search/notice/delete/v1', data).then(response => {
					if(response.data.result=='session_expired'){
						window.location.href='/#/pages/login'
					}
					self.$message.success('批量删除成功')
					self.get_message_data()
				})
			},
			set_message_as_read() {
				var ids = this.multipleSelection.map(item => item.id)
				var data = {
					'ids': JSON.stringify(ids)
				}
				var self = this
				fetchPost('/ro/tec_search/notice/set_as_read/v1', data).then(response => {
					if(response.data.result=='session_expired'){
											window.location.href='/#/pages/login'
										}
					self.$message.success('批量操作成功')
					self.get_message_data()
				})

			},

			handleCellClick(row, column, cell, event) {
				// 在这里处理点击列的操作
				console.log(row.url)
				console.log(row.id)
				var ids = []
				ids.push(row.id)
				var data = {
					'ids': JSON.stringify(ids)
				}
				var self = this
				fetchPost('/ro/tec_search/notice/set_as_read/v1', data).then(response => {
					if(response.data.result=='session_expired'){
											window.location.href='/#/pages/login'
										}
					self.get_message_data()
					self.$router.push(row.url)
				})
			},
			tableRowClassName({
				row,
				rowIndex
			}) {

				if (row.has_read) {
					return 'read-row';
				} else {
					return 'no-read-row';
				}
				return '';
			},
			get_message_data() {
				var data = {
					'id': localStorage.getItem('user_id'),
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				var self = this
				fetchPost('/ro/tec_search/notice/home_list/v1', data).then(response => {
					if(response.data.result=='session_expired'){
											window.location.href='/#/pages/login'
										}
					self.user_notice_datas = response.data.list
					self.totalCount =  response.data.totalCount
					localStorage.setItem('message_qty', response.data.message_qty)
				})
				var notify_message = localStorage.getItem('notify_message')
				var notify_title = localStorage.getItem('notify_title')
				this.notify_message = notify_message
				this.notify_title = notify_title
				// debugger
				
				if (notify_title!=''){
					this.notifyDialogVisible=true
					localStorage.setItem('notify_message', '')
					localStorage.setItem('notify_title', '')
				}
			
				
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			tabClick(row, column, cell, event) {
				switch (column.label) {
					case '顺序':
						this.tabClickIndex = row.index
						this.tabClickLabel = column.label
						break
					default:
						return
				}
				console.log('tabClick', this.tabClickIndex, row.adName, row.adSort)
			},

			check_data() {
				var self = this;
				// 产品数据
				// var product_ids = this.product_ids
				// 客户
				var customer_id = this.customer_id
				// 查询数据
				// debugger;
				var postdata = {
					// 'product_ids': product_ids.join(','),
					'customer_id': customer_id,
				}
				// debugger;
				fetchPost('/ro/report_data_center/cost/datas/check', postdata, ).then(function(data) {

					self.tableData = data.data['product_data']

				})


			}
		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}

	<style>.el-table .read-row {
		color: gray;
	}

	.el-table .no-read-row {
		color: red;
	}
</style>

</style>